export type MapBoxMapMode = "light" | "dark" | "streets" | "satellite";

/**
 * Helper function to get Mapbox style URL from map mode
 * @param mode - The map mode
 * @returns The Mapbox style URL
 */
export function getMapboxStyleUrl(mode: MapBoxMapMode): string {
  switch (mode) {
    case "satellite":
      return "mapbox://styles/mapbox/satellite-streets-v12";
    case "dark":
      return "mapbox://styles/mapbox/dark-v11";
    case "light":
      return "mapbox://styles/mapbox/light-v11";
    case "streets":
      return "mapbox://styles/mapbox/streets-v12";
    default:
      return "mapbox://styles/mapbox/light-v11";
  }
}
